<template>
    <div>
        <app-header>
            <template slot="left">
                <router-link to="/produkte">
                    <img src="./../assets/images/prev.svg" alt="">
                </router-link>
            </template>
            <template slot="title">Produkt Detail</template>
        </app-header>
        <div class="container">
            <div id="focus">
                <div class="row">
                    <div class="col-4">
                        <img :src="element.image">
                    </div>
                    <div class="col-8">
                        <div class="middle">
                            <div class="font-normal">{{ element.name }}</div>
                            <div class="font-normal">{{ element.performer }}</div>
                            <div class="font-small">asdasdasd424242</div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="list" class="table-wrapper-scroll-y">
                <table class="table">
                    <tbody>
                    <app-list-produkt-details v-for="item in element.details" :key="item.id"
                                              :id="item.id"
                                              :name="item.name"
                                              :code="item.code"
                                              :length="item.length"
                    ></app-list-produkt-details>
                    </tbody>
                </table>
            </div>
        </div>
        <app-nav></app-nav>
    </div>
</template>
<script>
  import Header from './../components/Header'
  import Nav from './../components/Nav'
  import data from '../data/products'
  import ListProduktDetails from '../components/produkte/ListProduktDetails'

  export default {
    props: ['produktID'],
    data () {
      return {
        id: this.$route.params.produktID,
        element: data.find(el => el.id === this.$route.params.produktID)
      }
    },
    components: {
      appHeader: Header,
      appNav: Nav,
      appListProduktDetails: ListProduktDetails
    }
  }
</script>

<style lang="scss" scoped>
    @import './../styles/app';

    .container {
        padding: 20px;
        #focus {
            padding-bottom: 20px;
            .font-small {
                color: $color-primary;
            }
            img {
                height: 110px;
                width: 110px;
            }
            .col-8 {
                padding-left: 10px;
                display: flex;
                align-items: center;
                .middle {
                    .font-normal:nth-of-type(1) {
                        font-weight: bold;
                    }
                }

            }
        }
    }

    .table-wrapper-scroll-y {
        display: block;
        max-height: 400px;
        overflow-y: auto;
        -ms-overflow-style: -ms-autohiding-scrollbar;
    }


</style>
